import { ASSET_BASE_URL } from '@/config';

export const PRESS_ARTICLE_DATA_PATH = `${ASSET_BASE_URL}/json-data/press-articles.json`;
